module.exports = __webpack_public_path__ + "img/hospital1.8e5fc967.png";